import React from 'react';
import Header from "../../Components/Header";




const Booking = () => {

    return (
        <>
        <Header />
       <h1>booking</h1>
           


        </>
    )
};

export default Booking;